import { render, staticRenderFns } from "./GoogleOAuthCallback.vue?vue&type=template&id=faf88f20&scoped=true"
import script from "./GoogleOAuthCallback.vue?vue&type=script&lang=js"
export * from "./GoogleOAuthCallback.vue?vue&type=script&lang=js"
import style0 from "./GoogleOAuthCallback.vue?vue&type=style&index=0&id=faf88f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf88f20",
  null
  
)

export default component.exports